import AddMessage from '../components/Post/AddMessage';

export default function AddMessagePage() {
  return <AddMessage />;
}
